import { Sort } from '@angular/material/sort';
import { Package } from '../../model';
import { DownloadsDatasource } from './downloads-datasource';

export class PackagesDatasource extends DownloadsDatasource<Package> {
  sortData(event: Sort, data: Array<Package>): Array<Package> {
    const sortHeader = <keyof Package>event.active;
    const direction =
      event.direction === '' ? 0 : event.direction === 'asc' ? 1 : -1;

    if (event.direction === '') {
      return data;
    }

    const sortedData = data.sort((a, b) => {
      let compareResult = 0;
      switch (sortHeader) {
        case 'published_date':
          compareResult = this.compareDateStrings(
            a.published_date,
            b.published_date,
          );
          break;
        case 'name':
        case 'version':
        case 'id':
          compareResult = this.compareStrings(a[sortHeader], b[sortHeader]);
          break;
        default:
          compareResult = 0;
          break;
      }

      return compareResult * direction;
    });

    return sortedData;
  }
}
